import styled from 'styled-components';
import { colors, fonts } from '../../settings';

export const StyledButton = styled.button`
  background-color: ${colors.transparent};
  color: ${colors.grey3};
  padding: 12px 20px;
  text-transform: uppercase;
  font-size: 14px;
  font-family: ${fonts.regular};
  margin: ${(props) => (props.margins ? '0 0 20px' : 0)};
`;
